export default [
  {  
    path: '/blog/brain-drain-in-a-new-dress',
    component: () => import(/* webpackChunkName: "brain-drain-in-a-new-dress" */ '../views/BlogPost.vue'),
    props: {
  "slug": "brain-drain-in-a-new-dress.md"
}
  },
  {  
    path: '/blog/building-a-scalable-translation-system',
    component: () => import(/* webpackChunkName: "building-a-scalable-translation-system" */ '../views/BlogPost.vue'),
    props: {
  "slug": "building-a-scalable-translation-system.md"
}
  },
  {  
    path: '/blog/burn-out-tales-from-a-remote-worker',
    component: () => import(/* webpackChunkName: "burn-out-tales-from-a-remote-worker" */ '../views/BlogPost.vue'),
    props: {
  "slug": "burn-out-tales-from-a-remote-worker.md"
}
  },
  {  
    path: '/blog/docker-crash-course',
    component: () => import(/* webpackChunkName: "docker-crash-course" */ '../views/BlogPost.vue'),
    props: {
  "slug": "docker-crash-course.md"
}
  },
  {  
    path: '/blog/engineering-management-is-a-different-craft-not-a-promotion',
    component: () => import(/* webpackChunkName: "engineering-management-is-a-different-craft-not-a-promotion" */ '../views/BlogPost.vue'),
    props: {
  "slug": "engineering-management-is-a-different-craft-not-a-promotion.md"
}
  },
  {  
    path: '/blog/google-doc-resume-download',
    component: () => import(/* webpackChunkName: "google-doc-resume-download" */ '../views/BlogPost.vue'),
    props: {
  "slug": "google-doc-resume-download.md"
}
  },
  {  
    path: '/blog/software-testing-in-the-ai-era',
    component: () => import(/* webpackChunkName: "software-testing-in-the-ai-era" */ '../views/BlogPost.vue'),
    props: {
  "slug": "software-testing-in-the-ai-era.md"
}
  }
]
